import { useState, useMemo, useLayoutEffect } from "react";
var m = {
  characterData: !0,
  characterDataOldValue: !0,
  childList: !0,
  subtree: !0
};
function p(c) {
  var a = window.getSelection();
  a.empty();
  a.addRange(c);
}
function q(c) {
  return (c.metaKey || c.ctrlKey) && !c.altKey && "KeyZ" === c.code;
}
function r(c) {
  c = [c.firstChild];
  for (var b, a = ""; b = c.pop();) {
    b.nodeType === Node.TEXT_NODE ? a += b.textContent : b.nodeType === Node.ELEMENT_NODE && "BR" === b.nodeName && (a += "\n"), b.nextSibling && c.push(b.nextSibling), b.firstChild && c.push(b.firstChild);
  }
  "\n" !== a[a.length - 1] && (a += "\n");
  return a;
}
function w(c) {
  var a = window.getSelection().getRangeAt(0),
    b = a.collapsed ? 0 : a.toString().length,
    f = document.createRange();
  f.setStart(c, 0);
  f.setEnd(a.startContainer, a.startOffset);
  return {
    position: c = (f = f.toString()).length,
    extent: b,
    content: f = (f = f.split("\n"))[a = f.length - 1],
    line: a
  };
}
function C(c, a, b) {
  0 >= a && (a = 0);
  if (!b || 0 > b) {
    b = a;
  }
  var f = document.createRange();
  c = [c.firstChild];
  for (var d, l = 0, g = a; d = c[c.length - 1];) {
    if (d.nodeType === Node.TEXT_NODE) {
      if (l + d.textContent.length >= g) {
        var h = g - l;
        if (g === a) {
          if (g = f, h < d.textContent.length ? g.setStart(d, h) : g.setStartAfter(d), b !== a) {
            g = b;
            continue;
          } else {
            break;
          }
        } else {
          a = f;
          h < (b = d).textContent.length ? a.setEnd(b, h) : a.setEndAfter(b);
          break;
        }
      }
      l += d.textContent.length;
    } else if (d.nodeType === Node.ELEMENT_NODE && "BR" === d.nodeName) {
      if (l + 1 >= g) {
        if (g === a) {
          if (h = f, 0 < d.textContent.length ? h.setStart(d, 0) : h.setStartAfter(d), b !== a) {
            g = b;
            continue;
          } else {
            break;
          }
        } else {
          a = f;
          0 < (b = d).textContent.length ? a.setEnd(b, 0) : a.setEndAfter(b);
          break;
        }
      }
      l++;
    }
    c.pop();
    d.nextSibling && c.push(d.nextSibling);
    d.firstChild && c.push(d.firstChild);
  }
  return f;
}
export function useEditable(c, a, b) {
  function f(k) {
    var b = c.current;
    if (b) {
      var a = w(b);
      b = r(b);
      a.position += k.length - b.length;
      e.position = a;
      e.onChange(k, a);
    }
  }
  function l(k, b) {
    var e = c.current;
    if (e) {
      var a = window.getSelection().getRangeAt(0);
      a.deleteContents();
      a.collapse();
      var d = b || 0;
      (a = C(e, b = (a = w(e)).position + (0 > d ? d : 0), a.position + (0 < d ? d : 0))).deleteContents();
      k && a.insertNode(document.createTextNode(k));
      p(C(e, b + k.length));
    }
  }
  function d(b) {
    var a = c.current;
    if (a) {
      a.focus();
      var e = 0;
      if ("number" == typeof b) {
        e = b;
      } else {
        var k = r(a).split("\n").slice(0, b.row);
        b.row && (e += k.join("\n").length + 1);
        e += b.column;
      }
      p(C(a, e));
    }
  }
  function g() {
    var b = c.current;
    return {
      text: r(b),
      position: b = w(b)
    };
  }
  function h() {
    e.observer.disconnect();
  }
  b || (b = {});
  var D = useState([])[1],
    e = useState(function () {
      var e = {
        observer: null,
        disconnected: !1,
        onChange: a,
        queue: [],
        history: [],
        historyAt: -1,
        position: null
      };
      "undefined" != typeof MutationObserver && (e.observer = new MutationObserver(function b(b) {
        var a;
        (a = e.queue).push.apply(a, b);
      }));
      return e;
    })[0],
    n = useMemo(function () {
      return {
        update: f,
        insert: l,
        move: d,
        getState: g
      };
    }, []);
  if ("object" != typeof navigator) {
    return n;
  }
  useLayoutEffect(function () {
    e.onChange = a;
    if (c.current && !b.disabled) {
      e.disconnected = !1;
      e.observer.observe(c.current, m);
      if (e.position) {
        var k = e.position,
          d = k.position;
        p(C(c.current, d, d + k.extent));
      }
      return h;
    }
  });
  useLayoutEffect(function () {
    if (!c.current || b.disabled) {
      e.history.length = 0, e.historyAt = -1;
    } else {
      var a = c.current;
      if (e.position) {
        a.focus();
        var d = e.position,
          f = d.position;
        p(C(a, f, f + d.extent));
      }
      var g = a.style.whiteSpace,
        h = a.contentEditable,
        l = !0;
      try {
        a.contentEditable = "plaintext-only";
      } catch (u) {
        a.contentEditable = "true", l = !1;
      }
      "pre" !== g && (a.style.whiteSpace = "pre-wrap");
      b.indentation && (a.style.tabSize = a.style.MozTabSize = "" + b.indentation);
      d = "" + " ".repeat(b.indentation || 0);
      var x,
        E = new RegExp("^(?:" + d + ")"),
        F = new RegExp("^(?:" + d + ")*(" + d + ")$"),
        t = function t(b) {
          if (c.current && e.position) {
            var u = r(a),
              d = w(a),
              f = new Date().valueOf(),
              g = e.history[e.historyAt];
            !b && 500 > f - x || g && g[1] === u ? x = f : (b = ++e.historyAt, e.history[b] = [d, u], e.history.splice(b + 1), 500 < b && (e.historyAt--, e.history.shift()));
          }
        },
        v = function v() {
          var b;
          (b = e.queue).push.apply(b, e.observer.takeRecords());
          b = w(a);
          if (e.queue.length) {
            e.observer.disconnect();
            e.disconnected = !0;
            var d = r(a);
            e.position = b;
            for (var c, f; c = e.queue.pop();) {
              null !== c.oldValue && (c.target.textContent = c.oldValue);
              for (f = c.removedNodes.length - 1; 0 <= f; f--) {
                c.target.insertBefore(c.removedNodes[f], c.nextSibling);
              }
              for (f = c.addedNodes.length - 1; 0 <= f; f--) {
                c.addedNodes[f].parentNode && c.target.removeChild(c.addedNodes[f]);
              }
            }
            e.onChange(d, b);
          }
        },
        y = function y(c) {
          if (!c.defaultPrevented && c.target === a) {
            if (e.disconnected) {
              return c.preventDefault(), D([]);
            }
            if (q(c)) {
              c.preventDefault(), c.shiftKey ? (c = ++e.historyAt, (c = e.history[c]) || (e.historyAt = e.history.length - 1)) : (c = --e.historyAt, (c = e.history[c]) || (e.historyAt = 0)), c && (e.observer.disconnect(), e.disconnected = !0, e.position = c[0], e.onChange(c[1], c[0]));
            } else {
              t();
              if ("Enter" === c.key) {
                c.preventDefault();
                var d = w(a),
                  f = /\S/g.exec(d.content);
                d = "\n" + d.content.slice(0, f ? f.index : d.content.length);
                n.insert(d);
              } else if ((!l || b.indentation) && "Backspace" === c.key) {
                c.preventDefault(), window.getSelection().getRangeAt(0).collapsed ? (d = w(a), d = F.exec(d.content), n.insert("", d ? -d[1].length : -1)) : n.insert("", 0);
              } else if (b.indentation && "Tab" === c.key) {
                c.preventDefault();
                f = (d = w(a)).position - d.content.length;
                var g = r(a);
                d = c.shiftKey ? g.slice(0, f) + d.content.replace(E, "") + g.slice(f + d.content.length) : g.slice(0, f) + (b.indentation ? " ".repeat(b.indentation) : "\t") + g.slice(f);
                n.update(d);
              }
              c.repeat && v();
            }
          }
        },
        z = function z(b) {
          b.defaultPrevented || b.isComposing || (q(b) || t(), v(), a.focus());
        },
        A = function A(b) {
          e.position = window.getSelection().rangeCount && b.target === a ? w(a) : null;
        },
        B = function B(a) {
          a.preventDefault();
          t(!0);
          n.insert(a.clipboardData.getData("text/plain"));
          t(!0);
          v();
        };
      document.addEventListener("selectstart", A);
      window.addEventListener("keydown", y);
      a.addEventListener("paste", B);
      a.addEventListener("keyup", z);
      return function () {
        document.removeEventListener("selectstart", A);
        window.removeEventListener("keydown", y);
        a.removeEventListener("paste", B);
        a.removeEventListener("keyup", z);
        a.style.whiteSpace = g;
        a.contentEditable = h;
      };
    }
  }, [c.current, b.disabled, b.indentation]);
  return n;
}